import { render, staticRenderFns } from "./PopulationCreate.vue?vue&type=template&id=4b915baf"
import script from "./PopulationCreate.vue?vue&type=script&lang=js"
export * from "./PopulationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports